import './src/vaadin-text-area.js';

export * from './src/vaadin-text-area.js';
